// @archigraph r8DljQiU
// @archigraph authenticates|ui.website|auth.cognito|security

export const config = {
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
    region: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
  },
  env: (import.meta.env.VITE_ENV || 'production') as 'local' | 'qa' | 'production',
  analytics: {
    gaTrackingId: import.meta.env.VITE_GA_TRACKING_ID || '',
  },
} as const;
